<template>
    <div class="ebso-info-banner">
        <div class="ebso-info-banner__inner">
            <strong>{{ $t('ebsoInfoRow.text') }}</strong>
        </div>
    </div>
</template>

<script>

export default {
    name: "EbsoInfoRow",
    props: {},
    components: {
    },
};
</script>

<style lang="scss" scoped>
.ebso-info-banner {
    width: 100%;
    background-color: #00e6a8;
    /* bright greenish-teal */
    color: #000;
    display: flex;
    justify-content: center;
    /* center inner container horizontally */
    text-align: center;
    padding: 0.5rem;
}

.ebso-info-banner {
    width: 100%;
    background-color: #00e6a8;
    /* bright greenish-teal */
    color: #000;
    display: flex;
    justify-content: center;
    /* center inner container horizontally */
}

.ebso-info-banner__inner {
    max-width: 1400px;
    /* controls line length; tweak as needed */
    text-align: center;
    /* center the text itself */
    font-size: 10px;
    line-height: 21px;
}

.ebso-info-banner__text {
    display: inline;
    /* keeps text inline with link */
}

.ebso-info-banner__link {
    font-weight: 700;
    color: inherit;
    cursor: pointer;
}
</style>
